import { TextField } from "@mui/material";
import { useContext, useState } from "react";
//Import from project
import useCheckStudentHomework from "../../../Hooks/useCheckStudentHomework";

export default function ExerciseHomework({ editData }) {
  return (
    <TextField
      fullWidth
      size="small"
      multiline
      sx={{
        ".css-12tl3rr-MuiInputBase-input-MuiOutlinedInput-input": {
          textAlign: "center",
          minWidth: 120,
        },
      }}
      className="text-field" 
      placeholder={"--:--"}
      value={editData?.exercise || ""}
    />
  );
}
